import React from "react";

const TreatmentPlanForm = ({ formData, handleChange }) => {
    const options = [
        { value: "initiate_medications", label: "Initiate medications at home" },
        { value: "continue_current", label: "Continue current medications" },
        { value: "refer_trh_outpatient", label: "Refer to TRH out-patient" },
        { value: "appropriate_trh_residential", label: "Appropriate for TRH residential care" },
        { value: "appropriate_drp", label: "Appropriate for DRP (Day Rehabilitation Program) Inappropriate for TRH services/ no further visits Emergency management only (single visit)" },
        { value: "refer_other", label: "Refer to any other service" }
    ];

    return (
        <>
            {/* Sticky Guidelines Button */}
            <div className="row mb-4 position-sticky top-0 bg-white pt-3" style={{ zIndex: 10 }}>
                <div className="col-md-3">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm w-100"
                        data-bs-toggle="modal"
                        data-bs-target="#treatmentGuidelines"
                    >
                        <i className="ri-information-line me-2"></i>
                        Treatment Plan Guidelines
                    </button>
                </div>
            </div>
            <div className="p-3" style={{ maxHeight: "60vh", overflowY: "auto", scrollbarWidth: "thin" }}>
                <div className="accordion" id="treatmentAccordion">
                    {/* Treatment Plan Section */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#treatmentPlan">
                                Treatment Plan
                            </button>
                        </h2>
                        <div id="treatmentPlan" className="accordion-collapse collapse show">
                            <div className="accordion-body pt-3">
                                <div className="row g-4">
                                    {options.map((opt) => (
                                        <div className="col-md-12" key={opt.value}>
                                            <div className="form-check mb-2">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="treatmentOption"
                                                    id={`opt_${opt.value}`}
                                                    value={opt.value}
                                                    checked={formData.treatmentOption === opt.value}
                                                    onChange={handleChange}
                                                />
                                                <label className="form-check-label fw-medium d-flex align-items-start"
                                                    htmlFor={`opt_${opt.value}`}>
                                                    <span>{opt.label}</span>
                                                </label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Reason Section */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#reason">
                                Reason
                            </button>
                        </h2>
                        <div id="reason" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <textarea className="form-control" name="reason" value={formData.reason || ""} onChange={handleChange} rows="4" />
                            </div>
                        </div>
                    </div>
                </div>
                {/* Guidelines Modal */}
                <div className="modal fade" id="treatmentGuidelines" tabIndex="-1">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <h5>Subsequent Home Visits</h5>
                                <p>1st Visit: one hour visit</p>
                                <ul>
                                    <li>30minutes for family psychoeducation of the care giver and "Engagement"</li>
                                    <li>30 minutes for client's initial assessment of condition, determine need & readiness for medication.</li>
                                </ul>
                                <p>2nd Visit: one hour visit</p>
                                <ul>
                                    <li>30minutes for family psychoeducation</li>
                                    <li>30 minutes for in-depth assessment of client's condition& Response to medication if it had been prescribed on previous medication.</li>
                                </ul>
                                <p>Institute changes or continues medication based on findings.</p>
                                <p>3rd Visit: One hour visit</p>
                                <ul>
                                    <li>Problem-solving session as part of Family Psych education with care giver & client.</li>
                                    <li>Assessment for Rehabilitation readiness & Initial Goal setting conversation</li>
                                </ul>
                                <p>4th Visit: One hour visit</p>
                                <ul>
                                    <li>Decision making session; Working with Client to determine client's willingness for psychiatric Rehabilitation as a Residential or day program participant.</li>
                                    <li>Educating Client on what he/she could expect from an individualized Rehabilitation Plan. Allow client to share his/her understanding, expectations, or reservations of either plan.</li>
                                    <li>The meeting ends with a decision for future management planand home services are terminated.</li>
                                </ul>
                                <p>Time slots allocated for Home Visits:</p>
                                <p>In the beginningtwo to three visits per week. Then can increase to up to three full days per week.</p>
                                <p>Coverage:</p>
                                <p>Nursing staff for attendants</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-primary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TreatmentPlanForm;